export default __webpack_public_path__ + "static/media/capa.7f7c1eaa.jpg";